import * as constAction from 'root/actionConstants';
import { Map, List, fromJS } from 'immutable';

var defaultState = Map({
  lista: List(),
  listaSeleccionados: List(),
  cuantosHay: 0,
  scrollControl: Map({
    hasMore: true,
    page: 0,
    fecha: null,
  }),
});

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case constAction.GRUPOS_SOLICITUDES_CLEAR: {
      if (action.payload === 'all') return defaultState;
      else if (defaultState.has(action.payload)) return state.set(action.payload, defaultState.get(action.payload));
      else {
        console.error('No existe la propiedad ' + action.payload);
        return state;
      }
    }
    case constAction.GRUPOS_SOLICITUDES_SET_STATE: {
      let newState = state;
      for (var key in action.payload) newState = newState.set(key, fromJS(action.payload[key]));
      return newState;
    }
    case constAction.GRUPOS_SOLICITUDES_SELECCIONAR: {
      let usuariosList = state.get('listaSeleccionados');
      let indexOf = usuariosList && usuariosList.indexOf(action.payload.solicitudId);
      if (indexOf !== -1 && !action.payload.seleccionada) return state.set('listaSeleccionados', usuariosList.delete(indexOf));
      else if (indexOf === -1 && action.payload.seleccionada) return state.set('listaSeleccionados', usuariosList.push(action.payload.solicitudId));
      return state;
    }
    case constAction.GRUPOS_SOLICITUDES_SELECCIONAR_TODAS: {
      if (!action.payload.seleccionar) return state.set('listaSeleccionados', List());
      let arrayIds = state.get('lista').size > 0 && state.get('lista').map(element => element.get('id'));;
      return state.set('listaSeleccionados', arrayIds);
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// src/modules/gruposSolicitudes/reducer.js